import { useField } from 'formik';
import { FormControl, FormControlLabel, FormHelperText, Switch } from '@mui/material';

interface FormikSwitchProps {
  name: string;
  label: string;
}

export const FormikSwitch = ({ name, label }: FormikSwitchProps) => {
  const [field, meta, helpers] = useField(name);
  const hasError = meta.touched && !!meta.error;

  return (
    <FormControl error={hasError}>
      <FormControlLabel
        sx={{ fontSize: '14px' }}
        control={
          <Switch
            checked={field.value}
            onChange={(e) => helpers.setValue(e.target.checked)}
            name={field.name}
            onBlur={field.onBlur}
          />
        }
        label={label}
      />
      {hasError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
